module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-primary"
  }, [_c('fieldset', {
    attrs: {
      "disabled": this.$router.currentRoute.name === 'proposta-visualiza'
    }
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Deferimento"), (_vm.deferimento.ds_codigo_projeto_erp) ? _c('span', [_vm._v(" do projeto "), _c('b', [_vm._v(_vm._s(_vm.deferimento.ds_codigo_projeto_erp))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('legend', [_vm._v("Datas")]), _vm._v(" "), _c('dl', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group col-md-12 required-field",
    class: {
      'has-error': _vm.errors.first('data deferimento')
    },
    attrs: {
      "uib-tooltip": "Data de deferimento"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Data do deferimento pelo comitê")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|validdate|dateeqpast'),
      expression: "'required|validdate|dateeqpast'"
    }],
    attrs: {
      "name": "data deferimento",
      "input-class": "form-control datepicker",
      "language": _vm.$datePickerPtBR,
      "use-utc": false,
      "format": "dd/MM/yyyy",
      "placeholder": "__/__/____"
    },
    model: {
      value: (_vm.deferimento.dt_deferimento),
      callback: function($$v) {
        _vm.$set(_vm.deferimento, "dt_deferimento", $$v)
      },
      expression: "deferimento.dt_deferimento"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('data deferimento')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('data deferimento')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('legend', [_vm._v("Documentos do Deferimento")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('upload-documentos-php-novo', {
    attrs: {
      "propDocumentos": _vm.deferimentoDocumentos,
      "documentTypes": '',
      "documentosObrigatorios": '',
      "localUso": 'PROPOSTA_DEFERIMENTO'
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('legend', [_vm._v("Decisões")]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12 required-field",
    class: {
      'has-error': _vm.errors.first('resultadoAprovacao')
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deferimento.resultadoAprovacao),
      expression: "deferimento.resultadoAprovacao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "resultadoAprovacao",
      "value": "APROVAR"
    },
    domProps: {
      "checked": _vm._q(_vm.deferimento.resultadoAprovacao, "APROVAR")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.deferimento, "resultadoAprovacao", "APROVAR")
      }
    }
  }), _vm._v("\n                  Deferir o Projeto (DEF)\n                  "), _c('div', {
    staticClass: "new-control-indicator"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deferimento.resultadoAprovacao),
      expression: "deferimento.resultadoAprovacao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "resultadoAprovacao",
      "value": "INDEFERIR"
    },
    domProps: {
      "checked": _vm._q(_vm.deferimento.resultadoAprovacao, "INDEFERIR")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.deferimento, "resultadoAprovacao", "INDEFERIR")
      }
    }
  }), _vm._v("\n                  Indeferir o Projeto (IND)\n                  "), _c('div', {
    staticClass: "new-control-indicator"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deferimento.resultadoAprovacao),
      expression: "deferimento.resultadoAprovacao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "resultadoAprovacao",
      "value": "VOLTAR_ANALISE"
    },
    domProps: {
      "checked": _vm._q(_vm.deferimento.resultadoAprovacao, "VOLTAR_ANALISE")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.deferimento, "resultadoAprovacao", "VOLTAR_ANALISE")
      }
    }
  }), _vm._v("\n                  Devolver para Reanálise\n                  "), _c('div', {
    staticClass: "new-control-indicator"
  })])]), _vm._v(" "), (_vm.errors.first('aprovacao')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('aprovacao')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.deferimento.resultadoAprovacao && _vm.deferimento.resultadoAprovacao !== 'APROVAR') ? _c('div', {
    staticClass: "form-group full col-md-12 required-field",
    class: {
      'has-error': _vm.errors.first('justificativa')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Justificativa")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deferimento.justificativa),
      expression: "deferimento.justificativa"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "justificativa"
    },
    domProps: {
      "value": (_vm.deferimento.justificativa)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.deferimento, "justificativa", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('justificativa')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('justificativa')))]) : _vm._e()]) : _vm._e()])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-de44d048!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/validação/proposta/deferimento.vue
// module id = 1963
// module chunks = 2